const { instance } = require('../../config/axios');

/**
 *
 * @param {string} fieldName
 * @param {object} body
 * @param {string} token
 * @returns {Promise} axios response
 */
const validateUniqueField = async (fieldName, body, token) => {
  const config = {
    'Content-Type': 'application/json',
    Authorization: token,
  };
  return instance.post(`fields/validate/${fieldName}/unique`, body, config);
};

/**
 *
 * @param {string} fieldName
 * @param {object} body
 * @param {token} token
 * @returns {Promise} axios response
 */
const validateUniqueBulk = async (fieldName, body, token) => {
  const config = {
    'Content-Type': 'application/json',
    Authorization: token,
  };
  return instance.post(`fields/validate/${fieldName}/unique/bulk`, body, config);
};

module.exports = { validateUniqueField, validateUniqueBulk };
